import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#031f30",
      d: "M14.875 13.75H1.125a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h13.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625M7.556 12.319A.6.6 0 0 0 8 12.5a.6.6 0 0 0 .238-.05.6.6 0 0 0 .206-.137l4.375-4.376a.623.623 0 1 0-.882-.88l-3.312 3.312V.625A.627.627 0 0 0 8 0a.627.627 0 0 0-.625.625v9.744L4.069 7.063a.622.622 0 1 0-.881.88z"
    }, null, -1)
  ]))]))
}
export default { render: render }